import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateObj'
})
export class DateObjPipe implements PipeTransform {
  transform(value: any, days?: any): any {

    if(!value) {
      return new Date(0);
    }
    let arr = value.split(' ')[0].split('-');
    let arr2;

    if (value.split(' ')[1]) {
      arr2 = value.split(' ')[1].split(':');

      if (days) {
          let date: Date = new Date(arr[0], arr[1]-1, arr[2], arr2[0], arr2[1], arr2[2]);
          return date.setDate(date.getDate() + days);
      }

      return new Date(arr[0], arr[1]-1, arr[2], arr2[0], arr2[1], arr2[2]);
    }

    return new Date(arr[0], arr[1]-1, arr[2]);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/pipes/date-obj.pipe.ts